export default {
    "AU": {
        "name": "Австралія"
    },
    "AT": {
        "name": "Австрія"
    },
    "AZ": {
        "name": "Азербайджан"
    },
    "AL": {
        "name": "Албанія"
    },
    "DZ": {
        "name": "Алжир"
    },
    "AO": {
        "name": "Ангола"
    },
    "AD": {
        "name": "Андорра"
    },
    "AG": {
        "name": "Антигуа і Барбуда"
    },
    "AR": {
        "name": "Аргентина"
    },
    "AF": {
        "name": "Афганістан"
    },
    "BS": {
        "name": "Багамські Острови"
    },
    "BD": {
        "name": "Бангладеш"
    },
    "BB": {
        "name": "Барбадос"
    },
    "BH": {
        "name": "Бахрейн"
    },
    "BZ": {
        "name": "Беліз"
    },
    "BE": {
        "name": "Бельгія"
    },
    "BJ": {
        "name": "Бенін"
    },
    "BY": {
        "name": "Білорусь"
    },
    "BG": {
        "name": "Болгарія"
    },
    "BO": {
        "name": "Болівія"
    },
    "BA": {
        "name": "Боснія і Герцеговина"
    },
    "BW": {
        "name": "Ботсвана"
    },
    "BR": {
        "name": "Бразилія"
    },
    "BN": {
        "name": "Бруней"
    },
    "BF": {
        "name": "Буркіна-Фасо"
    },
    "BI": {
        "name": "Бурунді"
    },
    "BT": {
        "name": "Бутан"
    },
    "VU": {
        "name": "Вануату"
    },
    "GB": {
        "name": "Велика Британія"
    },
    "VE": {
        "name": "Венесуела"
    },
    "VN": {
        "name": "В'єтнам"
    },
    "AM": {
        "name": "Вірменія"
    },
    "GA": {
        "name": "Габон"
    },
    "HT": {
        "name": "Гаїті"
    },
    "GY": {
        "name": "Гаяна"
    },
    "GM": {
        "name": "Гамбія"
    },
    "GH": {
        "name": "Гана"
    },
    "GT": {
        "name": "Гватемала"
    },
    "GN": {
        "name": "Гвінея"
    },
    "GW": {
        "name": "Гвінея-Бісау"
    },
    "HN": {
        "name": "Гондурас"
    },
    "GD": {
        "name": "Гренада"
    },
    "GR": {
        "name": "Греція"
    },
    "GE": {
        "name": "Грузія"
    },
    "DK": {
        "name": "Данія"
    },
    "CD": {
        "name": "ДР Конго"
    },
    "DJ": {
        "name": "Джибуті"
    },
    "DM": {
        "name": "Домініка"
    },
    "DO": {
        "name": "Домініканська Республіка"
    },
    "EC": {
        "name": "Еквадор"
    },
    "GQ": {
        "name": "Екваторіальна Гвінея"
    },
    "ER": {
        "name": "Еритрея"
    },
    "EE": {
        "name": "Естонія"
    },
    "ET": {
        "name": "Ефіопія"
    },
    "EG": {
        "name": "Єгипет"
    },
    "YE": {
        "name": "Ємен"
    },
    "ZM": {
        "name": "Замбія"
    },
    "ZW": {
        "name": "Зімбабве"
    },
    "IL": {
        "name": "Ізраїль"
    },
    "IN": {
        "name": "Індія"
    },
    "ID": {
        "name": "Індонезія"
    },
    "IQ": {
        "name": "Ірак"
    },
    "IR": {
        "name": "Іран"
    },
    "IE": {
        "name": "Ірландія"
    },
    "IS": {
        "name": "Ісландія"
    },
    "ES": {
        "name": "Іспанія"
    },
    "IT": {
        "name": "Італія"
    },
    "JO": {
        "name": "Йорданія"
    },
    "CV": {
        "name": "Кабо-Верде"
    },
    "KZ": {
        "name": "Казахстан"
    },
    "KH": {
        "name": "Камбоджа"
    },
    "CM": {
        "name": "Камерун"
    },
    "CA": {
        "name": "Канада"
    },
    "QA": {
        "name": "Катар"
    },
    "KE": {
        "name": "Кенія"
    },
    "KG": {
        "name": "Киргизстан"
    },
    "CN": {
        "name": "Китайська Народна Республіка"
    },
    "CY": {
        "name": "Кіпр"
    },
    "KI": {
        "name": "Кірибаті"
    },
    "CO": {
        "name": "Колумбія"
    },
    "KM": {
        "name": "Коморські Острови"
    },
    "CG": {
        "name": "Республіка Конго"
    },
    "CR": {
        "name": "Коста-Рика"
    },
    "CI": {
        "name": "Кот-д'Івуар"
    },
    "CU": {
        "name": "Куба"
    },
    "KW": {
        "name": "Кувейт"
    },
    "LA": {
        "name": "Лаос"
    },
    "LV": {
        "name": "Латвія"
    },
    "LS": {
        "name": "Лесото"
    },
    "LT": {
        "name": "Литва"
    },
    "LR": {
        "name": "Ліберія"
    },
    "LB": {
        "name": "Ліван"
    },
    "LY": {
        "name": "Лівія"
    },
    "LI": {
        "name": "Ліхтенштейн"
    },
    "LU": {
        "name": "Люксембург"
    },
    "MU": {
        "name": "Маврикій"
    },
    "MR": {
        "name": "Мавританія"
    },
    "MG": {
        "name": "Мадагаскар"
    },
    "MW": {
        "name": "Малаві"
    },
    "MY": {
        "name": "Малайзія"
    },
    "ML": {
        "name": "Малі"
    },
    "MV": {
        "name": "Мальдіви"
    },
    "MT": {
        "name": "Мальта"
    },
    "MA": {
        "name": "Марокко"
    },
    "MH": {
        "name": "Маршаллові Острови"
    },
    "MX": {
        "name": "Мексика"
    },
    "MZ": {
        "name": "Мозамбік"
    },
    "MD": {
        "name": "Молдова"
    },
    "MC": {
        "name": "Монако"
    },
    "MN": {
        "name": "Монголія"
    },
    "MM": {
        "name": "М'янма"
    },
    "NA": {
        "name": "Намібія"
    },
    "NR": {
        "name": "Науру"
    },
    "NP": {
        "name": "Непал"
    },
    "NE": {
        "name": "Нігер"
    },
    "NG": {
        "name": "Нігерія"
    },
    "NL": {
        "name": "Нідерланди"
    },
    "NI": {
        "name": "Нікарагуа"
    },
    "DE": {
        "name": "Німеччина"
    },
    "NZ": {
        "name": "Нова Зеландія"
    },
    "NO": {
        "name": "Норвегія"
    },
    "AE": {
        "name": "ОАЕ"
    },
    "OM": {
        "name": "Оман"
    },
    "PK": {
        "name": "Пакистан"
    },
    "PW": {
        "name": "Палау"
    },
    "PA": {
        "name": "Панама"
    },
    "PG": {
        "name": "Папуа Нова Гвінея"
    },
    "PY": {
        "name": "Парагвай"
    },
    "PE": {
        "name": "Перу"
    },
    "ZA": {
        "name": "ПАР"
    },
    "KR": {
        "name": "Південна Корея"
    },
    "SS": {
        "name": "Південний Судан"
    },
    "KP": {
        "name": "Північна Корея"
    },
    "MK": {
        "name": "Північна Македонія"
    },
    "PL": {
        "name": "Польща"
    },
    "PT": {
        "name": "Португалія"
    },
    "RU": {
        "name": "Росія"
    },
    "RW": {
        "name": "Руанда"
    },
    "RO": {
        "name": "Румунія"
    },
    "SV": {
        "name": "Сальвадор"
    },
    "WS": {
        "name": "Самоа"
    },
    "SM": {
        "name": "Сан-Марино"
    },
    "ST": {
        "name": "Сан-Томе і Принсіпі"
    },
    "SA": {
        "name": "Саудівська Аравія"
    },
    "SZ": {
        "name": "Есватіні"
    },
    "SC": {
        "name": "Сейшельські Острови"
    },
    "SN": {
        "name": "Сенегал"
    },
    "VC": {
        "name": "Сент-Вінсент і Гренадини"
    },
    "KN": {
        "name": "Сент-Кіттс і Невіс"
    },
    "LC": {
        "name": "Сент-Люсія"
    },
    "RS": {
        "name": "Сербія"
    },
    "SY": {
        "name": "Сирія"
    },
    "SG": {
        "name": "Сінгапур"
    },
    "SK": {
        "name": "Словаччина"
    },
    "SI": {
        "name": "Словенія"
    },
    "SB": {
        "name": "Соломонові Острови"
    },
    "SO": {
        "name": "Сомалі"
    },
    "US": {
        "name": "США"
    },
    "SD": {
        "name": "Судан"
    },
    "SR": {
        "name": "Суринам"
    },
    "TL": {
        "name": "Східний Тимор"
    },
    "SL": {
        "name": "Сьєрра-Леоне"
    },
    "TJ": {
        "name": "Таджикистан"
    },
    "TH": {
        "name": "Таїланд"
    },
    "TZ": {
        "name": "Танзанія"
    },
    "TG": {
        "name": "Того"
    },
    "TO": {
        "name": "Тонга"
    },
    "TT": {
        "name": "Тринідад і Тобаго"
    },
    "TV": {
        "name": "Тувалу"
    },
    "TN": {
        "name": "Туніс"
    },
    "TR": {
        "name": "Туреччина"
    },
    "TM": {
        "name": "Туркменістан"
    },
    "UG": {
        "name": "Уганда"
    },
    "HU": {
        "name": "Угорщина"
    },
    "UZ": {
        "name": "Узбекистан"
    },
    "UA": {
        "name": "Україна"
    },
    "UY": {
        "name": "Уругвай"
    },
    "FM": {
        "name": "Федеративні Штати Мікронезії"
    },
    "FJ": {
        "name": "Фіджі"
    },
    "PH": {
        "name": "Філіппіни"
    },
    "FI": {
        "name": "Фінляндія"
    },
    "FR": {
        "name": "Франція"
    },
    "HR": {
        "name": "Хорватія"
    },
    "CF": {
        "name": "ЦАР"
    },
    "TD": {
        "name": "Чад"
    },
    "CZ": {
        "name": "Чехія"
    },
    "CL": {
        "name": "Чилі"
    },
    "ME": {
        "name": "Чорногорія"
    },
    "CH": {
        "name": "Швейцарія"
    },
    "SE": {
        "name": "Швеція"
    },
    "LK": {
        "name": "Шрі-Ланка"
    },
    "JM": {
        "name": "Ямайка"
    },
    "JP": {
        "name": "Японія"
    }
}